import { Injectable, inject } from '@angular/core';

import { WINDOW } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';

/**
 * Wrapper around MutationObserver API
 */
@Injectable({ providedIn: 'root' })
export class MutationObserverService {
    private defaultOptions: MutationObserverInit = {
        childList: true,
        subtree: true,
    };

    private readonly _window = inject(WINDOW);

    /*
     * Provides an observable stream of DOM changes for a given element
     * */
    observe(element: HTMLElement, options: MutationObserverInit = this.defaultOptions): Observable<MutationRecord[]> {
        return new Observable<MutationRecord[]>((observer) => {
            let mutationObserver: MutationObserver | undefined;

            if (this.isMutationObserverSupported) {
                mutationObserver = new MutationObserver((mutations: MutationRecord[]) => {
                    observer.next(mutations);
                });

                mutationObserver.observe(element, options);
            }

            const unsubscribe = () => {
                if (mutationObserver) {
                    mutationObserver.disconnect();
                }
            };

            return unsubscribe;
        });
    }

    private get isMutationObserverSupported(): boolean {
        return 'MutationObserver' in this._window;
    }
}
